import { useAnalyticsAccess } from '../../hooks/useAnalyticsAccess';
import Analytics from '../Admin/Analytics';

export default function AnalyticsPage() {
  const { hasAnalyticsAccess, environmentInfo, accessReason } = useAnalyticsAccess();

  if (!hasAnalyticsAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center theme-surface">
        <div className="text-center p-8 max-w-md">
          <div className="mb-4">
            <svg className="h-16 w-16 text-orange-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold theme-text mb-2">Analytics Access Restricted</h2>
          <p className="theme-text-muted mb-4">
            You don't have permission to view analytics data.
          </p>
          <div className="text-xs theme-text-muted p-3 bg-gray-100 dark:bg-gray-700 rounded">
            <p><strong>Environment:</strong> {environmentInfo.environment}</p>
            <p><strong>Access Status:</strong> {accessReason}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen theme-surface">
      {/* Page Header */}
      <div className="border-b border-gray-200 dark:border-gray-700 theme-card">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                  <svg className="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold theme-text">Analytics Dashboard</h1>
                  <p className="text-xs theme-text-muted">Community insights and metrics</p>
                </div>
              </div>
            </div>

            {/* Environment Badge */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                  environmentInfo.isProduction 
                    ? 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
                    : environmentInfo.isStaging
                    ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300'  
                    : 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
                }`}>
                  {environmentInfo.environment.toUpperCase()}
                </span>
                {environmentInfo.analyticsPublicAccess && (
                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300">
                    Public Access
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Analytics Content */}
      <main className="bg-gray-50 dark:bg-gray-900 min-h-screen">
        <Analytics />
      </main>
    </div>
  );
}